import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id", "name"]
const _hoisted_2 = { class: "checkbox-group__checkboxes" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-checkbox-group',
},
  __name: 'checkbox-group',
  props: {
  id: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  errorMessage: {
    type: String,
    required: true,
  },
  hideLabel: {
    type: Boolean,
    required: true,
  },
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["n-input", { 'has-error': __props.errorMessage }])
  }, [
    _createElementVNode("fieldset", {
      id: __props.id,
      name: __props.name,
      class: "checkbox-group"
    }, [
      _createElementVNode("legend", {
        class: _normalizeClass({ 'sr-only': __props.hideLabel })
      }, _toDisplayString(__props.label), 3),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ], 8, _hoisted_1),
    (__props.errorMessage)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.errorMessage), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})